import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const DotsVerticalBase = (
  <path
    fill='currentColor'
    d='M2 30.5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-8c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM2 15c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-7.5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM2 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z'
  />
)

export const DotsVertical = createIcon({
  displayName: 'DotsVertical',
  viewBox: '0 0 4 35',
  path: DotsVerticalBase,
})
